import { render, staticRenderFns } from "./goodsOrders.vue?vue&type=template&id=10433443&scoped=true"
import script from "./goodsOrders.vue?vue&type=script&lang=js"
export * from "./goodsOrders.vue?vue&type=script&lang=js"
import style0 from "./goodsOrders.vue?vue&type=style&index=0&id=10433443&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10433443",
  null
  
)

export default component.exports